import React from 'react'
import Map from '../components/Map'

export default function Maps({markers}) {
  const center = { lat: 60.1699, lng: 24.9384 };
  /* 60.1699° N, 24.9384° E. */
  const zoom = 13;
  

  return (
    <div className="Map">
      <Map center={center} zoom={zoom} markers={markers} />
    </div>
  );
}
